import api from './api';
import {
  IConteoStock,
  IConteoStockCreatePayload,
  IConteoStockCreateResponse,
  IConteoStockListParams,
  IConteoStockPagedResult,
  IStockUbicacion,
} from '../interfaces/ConteoStock';

/** Extrae nro/nombre de ubicación desde FormularioDto (listado/detalle). */
export function extractUbicacionFromFormulario(data: any): {
  nroUbicacion: number | null;
  detUbicacion: string | null;
} {
  const cabecera = data?.conteo ?? data?.formulario ?? data ?? {};
  const itemsData: any[] = data?.items ?? cabecera?.items ?? [];

  const candidates = [
    cabecera?.nroUbicacion,
    cabecera?.NroUbicacion,
    cabecera?.nroUbicacionOrigen,
    cabecera?.NroUbicacionOrigen,
    cabecera?.nroUbicacionDestino,
    cabecera?.NroUbicacionDestino,
    ...itemsData.flatMap((it) => [
      it?.nroUbicacion,
      it?.NroUbicacion,
      it?.nroUbicacionDestino,
      it?.NroUbicacionDestino,
      it?.nroUbicacionOrigen,
      it?.NroUbicacionOrigen,
    ]),
  ];

  let nroUbicacion: number | null = null;
  for (const v of candidates) {
    const n = Number(v);
    if (Number.isFinite(n) && n > 0) {
      nroUbicacion = n;
      break;
    }
  }

  const detRaw =
    cabecera?.detUbicacion ??
    cabecera?.DetUbicacion ??
    cabecera?.detUbicacionOrigen ??
    cabecera?.DetUbicacionOrigen ??
    cabecera?.detUbicacionDestino ??
    cabecera?.DetUbicacionDestino ??
    cabecera?.nombreUbicacion ??
    cabecera?.NombreUbicacion ??
    null;

  const detUbicacion =
    typeof detRaw === 'string' && detRaw.trim() ? detRaw.trim() : null;

  return { nroUbicacion, detUbicacion };
}

const conteoStockService = {
  getConteos: async (params: IConteoStockListParams): Promise<IConteoStockPagedResult> => {
    // Swagger: PageSize máximo 20; parámetros en PascalCase
    const pageSize = Math.min(Math.max(params.pageSize || 10, 1), 20);
    const queryParams: Record<string, string | number> = {
      PageNumber: params.pageNumber,
      PageSize: pageSize,
    };
    if (params.searchTerm) queryParams.SearchTerm = params.searchTerm;
    if (params.fechaDesde) queryParams.FechaDesde = params.fechaDesde;
    if (params.fechaHasta) queryParams.FechaHasta = params.fechaHasta;
    if (params.nroSuc != null && params.nroSuc > 0) queryParams.NroSuc = params.nroSuc;

    const response = await api.get('/api/Conteos', { params: queryParams });
    return response.data;
  },

  getConteo: async (nroFormulario: number): Promise<IConteoStock> => {
    const response = await api.get(`/api/Conteos/${nroFormulario}`);
    return response.data;
  },

  getStockUbicacion: async (
    codigoArticulo: string,
    nroUbicacion: number,
  ): Promise<IStockUbicacion> => {
    const response = await api.get('/api/Conteos/stock-ubicacion', {
      params: { codigoArticulo, nroUbicacion },
    });
    return response.data;
  },

  createConteo: async (payload: IConteoStockCreatePayload): Promise<IConteoStockCreateResponse> => {
    const response = await api.post('/api/Conteos', payload);
    return response.data;
  },
};

export default conteoStockService;
